import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { finalize } from 'rxjs/operators';
import { Alertado } from './../../../../_entities/consola/alertados';
import { AlertadosService } from './../../services/alertados.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit, AfterContentInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ImprimirPdfComponent } from '../imprimir-pdf/imprimir-pdf.component';
import { ALERTAS } from './../../../../_entities/estados';
import { environment } from './../../../../../environments/environment';


@Component({
	selector: 'kt-alertados',
	templateUrl: './alertados.component.html',
	styleUrls: ['./alertados.component.scss']
})
export class AlertadosComponent implements OnInit, AfterContentInit {
	public busquedaForm: FormGroup;
	public listaAlertados: Alertado[] = [];
	public titulo: String = 'Alertados';
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public loadingVisible: boolean = false;
	public isDisabled: boolean = true;
	public datosReporte = [];
	public mensajeAgrupar: string = "Arrastre un encabezado de columna aquí para agrupar por esa columna"
	public loadingMessage: string = 'Cargando...';


	public interval = null;

	constructor(private alertadosService: AlertadosService,
		private toastService: ToastrService,
		public dialog: MatDialog,
		private router: Router,
		private fb: FormBuilder,
		private datepipe: DatePipe) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;

	}

	ngOnInit() {
		this.obtenerListaAlertados();
	}

	ngAfterContentInit() {
		this.interval = setInterval(async () => {
			this.loadingMessage = 'Actualizando...';
			this.obtenerListaAlertados();
		}, 30000);
	}

	ngOnDestroy() {
		clearInterval(this.interval);
	}

	obtenerListaAlertados() {
		this.loadingVisible = true;
		this.alertadosService.obtenerAlertados().pipe(
			finalize(
				() => this.loadingVisible = false
			)
		).subscribe(
			(alertados: Alertado[]) => {
				if (alertados.length === 0) {
					this.toastService.warning('Sin datos existentes');
				}
				alertados.map(alertado => {
					alertado.fechaHora = this.datepipe.transform(alertado.fechaHora, 'HH:mm:ss a');

					const estado = ALERTAS.find(alerta => alerta.id == alertado.estado);
					alertado.estado = estado.nombre;

					if (alertado.velocidad !== null) {
						alertado.velocidad = alertado.velocidad + ' Km/h'
					}
				})

				this.listaAlertados = alertados.sort(function (a, b) {
					if (a.fechaHora > b.fechaHora) {
						return 1;
					}
					if (a.fechaHora < b.fechaHora) {
						return -1;
					}
					return 0;
				});

				this.listaAlertados.forEach(alertado => {
					let link = `${environment.EXTERNAL_MAP}/ubicar?lat=${alertado.lat}&lng=${alertado.lng}`

					this.datosReporte.push({
						'Ubicacion': {
							f: '=HYPERLINK("' + link + '","Ubicar")',
							v: link
						},
						'IMEI': alertado.imei.toString(),
						'Económio': alertado.economico,
						'Placas': alertado.nombreCliente,
						'Latitud': alertado.lat,
						'Longitud': alertado.lng,
						'Fecha y Hora': alertado.fechaHora,
						'Velocidad': alertado.velocidad,
						'Marca': alertado.marca,
						'Modelo': alertado.modelo,
						'Estado': alertado.estado
					});
				});

				if (this.datosReporte.length > 0) {
					this.isDisabled = false;
				}

			}, (error) => {
				this.toastService.error('Ocurrio un error al obtener datos')
			}
		)
	}


	navegarMaqueta() {
		this.router.navigateByUrl('/home/administracion/consola/reportes/maqueta');
	}

	navegarTranmisiones() {
		this.router.navigateByUrl('/home/administracion/consola/reportes/transmisiones');
	}

	navegarSinTransmitir() {
		this.router.navigateByUrl('/home/administracion/consola/reportes/sin-transmitir');
	}

	navegarGaleria() {
		this.router.navigateByUrl('/home/administracion/consola/clientes')
	}

	navegarFoto() {
		this.router.navigateByUrl('/home/administracion/consola/fotografias')
	}

	onRowPrepared(e) {
		if (e.rowType == 'data') {
			switch (e.data.estado) {
				case 'Alerta Primaria': //'Alerta Primaria'; roj0
					e.rowElement.style.backgroundColor = 'rgb(220 20 60 / 70%)';
					e.rowElement.style.color = 'white'
					e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
					break;
				case 'Alerta Secundaria': // 'Alerta Secundaria'; amarillo
					e.rowElement.style.backgroundColor = 'rgb(249 249 70 / 70%)';
					//e.rowElement.style.color = 'white'
					e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
					break;
				case 'Bateria Baja': //'Bateria Baja'; cafe
					e.rowElement.style.backgroundColor = 'rgb(138 93 19 / 70%)';
					e.rowElement.style.color = 'white'
					e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
					break;
				case 'Falta de Energía': //'Falta de Energía'; rosa
					e.rowElement.style.backgroundColor = 'rgb(202 51 255 / 70%)';
					e.rowElement.style.color = 'white'
					e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
					break;
				case 'Alerta de Movimiento': //'Alerta de Movimiento'; verde
					e.rowElement.style.backgroundColor = 'rgb(25 156 23 / 70%)';
					e.rowElement.style.color = 'white'
					e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
					break;
			}
		}
	}

	abrirImprimir(rowData) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "70%";
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.data = rowData
		this.dialog.open(ImprimirPdfComponent, dialogConfig).afterClosed().subscribe(() => {
		});
	}
}
